<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-cod-postales
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-map-marker-alt mr-2'></i> Codigo Postal</h4>"
          v-else
        ></table-cod-postales>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableCodPostales from "./TableCodPostales";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "partners",
  components: {
    TableCodPostales,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre(Código)", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getCodPostales();
  },
  methods: {
    getCodPostales() {
      var codPostales = store.getters.getCodPostales;
      if (codPostales.length == 0) {
        this.isLoading = true;
        store.dispatch("getCodPostales").then(() => {
          codPostales = store.getters.getCodPostales;
          shuffleArray([codPostales]);
          this.isLoading = false;
          this.items = codPostales;
          this.itemsArray = codPostales;
        });
      } else {
        shuffleArray([codPostales]);
        this.items = codPostales;
        this.itemsArray = codPostales;
      }
    }
  }
};
</script>
